'use strict';

var processInclude = require('base:util');

$(document).ready(function () {
    // Include base details
    processInclude(require('~/product/detail'));
    processInclude(require('~/product/pdpInstoreInventory'));
    processInclude(require('~/product/technicalSheetUpdate'));
    // plugin for the polarization effect on PDP Polarization Benefits section
    processInclude(require('~/components/sideBySideImages'));

    // plugin for the zoom effect on PDP Image section
    processInclude(require('~/components/productZoomImage'));

    processInclude(require('~/components/loadVideo'));
    //plugin for loading 3d-model
    processInclude(require('~/components/load3dModel'));
    processInclude(require('~/product/pdpRX'));
    // Gift Registry
    try {
        processInclude(require('giftregistry:product/giftRegistry'));
    } catch (ex) {
    // plugin not in use
    }

    // Apple pay
    try {
        processInclude(require('~/product/applepay'));
    } catch (ex) {
    // plugin not in use
    }

    // Wishlists
    try {
        processInclude(require('wishlist:product/wishlist'));
    } catch (ex) {
    // plugin not in use
    }
});
